import axios from 'axios';
const notification = {
    
	actions: {
		processnotification(context, userdata){
			return new Promise((resolve, reject) => {				
				axios({url: '/Notification/ProcessNotification', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(respdata => {	                   									
					resolve(respdata)
				})
				.catch(err => {									
					reject(err)
				})
			})
		},	
		getnotification({rootState}){
			return new Promise((resolve, reject) => {				
				axios.get('/Notification/GetNotification?Username='+rootState.auth.token)
				.then(resp => resp.data)
				.then(respdata => {					
					resolve(respdata)
				})
				.catch(err => {					
					reject(err)
				})
			})
		},   
		getnotificationbyid({rootState},Id){
			return new Promise((resolve, reject) => {				
				axios.get('/Notification/GetNotificationbyId?Id='+Id+'&Username='+rootState.auth.token)
				.then(resp => resp.data)
				.then(respdata => {					
					resolve(respdata)
				})
				.catch(err => {					
					reject(err)
				})
			})
		},   
		getnotificationbysearch({rootState},searchVal){
			return new Promise((resolve, reject) => {				
				axios.get('/Notification/GetNotificationbySearch?SearchItem='+searchVal+'&Username='+rootState.auth.token)
				.then(resp => resp.data)
				.then(respdata => {					
					resolve(respdata)
				})
				.catch(err => {					
					reject(err)
				})
			})
		}    
	}
}

export default notification